var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenEtat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pen-svgrepo-com 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53856 3.26607C10.5592 2.24546 12.2139 2.24546 13.2346 3.26607C14.2552 4.28668 14.2552 5.94142 13.2346 6.96203L7.94044 12.2562C7.63798 12.5586 7.45988 12.7367 7.2618 12.8912C7.02838 13.0733 6.77574 13.2294 6.50846 13.3568C6.28168 13.4649 6.04279 13.5445 5.63696 13.6797L3.77773 14.2995L3.33006 14.4487C2.96696 14.5698 2.56663 14.4753 2.29599 14.2046C2.02535 13.934 1.93085 13.5336 2.05188 13.1706L2.82084 10.8637C2.95611 10.4578 3.03573 10.2189 3.1438 9.99217C3.27119 9.72488 3.42731 9.47227 3.60942 9.2388C3.76391 9.04071 3.94198 8.86267 4.24448 8.56016L9.53856 3.26607ZM3.75842 13.4234L5.34438 12.8948C5.78593 12.7476 5.97354 12.6843 6.14827 12.601C6.36067 12.4998 6.5614 12.3758 6.74693 12.231C6.89957 12.112 7.04005 11.9725 7.36918 11.6434L11.594 7.4186C11.1538 7.26333 10.5867 6.97556 10.0559 6.4447C9.52505 5.91384 9.23727 5.34678 9.08206 4.90661L4.85721 9.13141C4.5281 9.46055 4.38861 9.60103 4.26956 9.75368C4.12486 9.93921 4.00079 10.1399 3.89958 10.3523C3.8163 10.527 3.753 10.7147 3.60582 11.1562L3.07716 12.7422L3.75842 13.4234ZM9.76114 4.22751C9.78023 4.32517 9.81249 4.45791 9.8663 4.61309C9.98752 4.96247 10.2165 5.42128 10.6479 5.85271C11.0793 6.28413 11.5381 6.51309 11.8875 6.6343C12.0427 6.68814 12.1754 6.7204 12.2731 6.73948L12.6425 6.37003C13.3362 5.67637 13.3362 4.55173 12.6425 3.85807C11.9489 3.1644 10.8242 3.1644 10.1306 3.85807L9.76114 4.22751Z",
    fill: "#535353"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenEtat);
export default __webpack_public_path__ + "static/media/PenEtat.fb607a80073c978dc79d3ac2f20d87e9.svg";
export { ForwardRef as ReactComponent };